export default __webpack_public_path__ + "static/media/east_african_federation.2dd18f4c.svg";